import { 
  ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { 
  ClickStopPropagationDirective 
} from '@modules/shared/directives/click-stop-propagation.directive';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
    selector: 'app-form-switch',
    imports: [CommonModule, ClickStopPropagationDirective],
    templateUrl: './form-switch.component.html',
    styleUrls: ['./form-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormSwitchComponent implements OnInit {
  @Input() checkboxValue = false;
  @Input() disabled = false;
  @Output() toggleCallback = new EventEmitter<boolean>();

  public checkboxChanges$: Observable<boolean>;
  private _checkboxChanges$: BehaviorSubject<boolean>;

  ngOnInit(): void {
    this._checkboxChanges$ = new BehaviorSubject(this.checkboxValue);
    this.checkboxChanges$ = this._checkboxChanges$.asObservable();
  }

  protected toggleSwitch(): void {
    this._checkboxChanges$.next(!this._checkboxChanges$.getValue());
    this.toggleCallback.emit(this._checkboxChanges$.getValue()); 
  }
}